export default {
  title: 'list products',
  search:'search ...',
  id: 'id',
  name_fa : 'name fa',
  name_en: 'name en',
  price_irr: 'price irr',
  price_usd: 'price usd',
  stock_total: 'stock total',
  stock_reserved: 'stock reserved',
  stock_visible: 'stock visible',
  status: 'status',
  statusActive: 'active',
  statusInActive: 'inactive',
  loading:'loading ... ',
  operating:'operating',
  empty:'list is empty',
  next:'Next',
  previous:'Previous',
  success:'success',
  deleteConfirm:'Are you sure you want to delete this product?'
}
